/**
 * Little helper to inject optimisemedia snippet on the page
 * @module lib/optimisemedia_tracker
 */

/**
 * Generates an analytics snippet
 */
function optimiseSnippet() {
  return `OMID=2107388;OPID=38300;ORef=escape((window.location != window.parent.location) ? document.referrer: document.location.href);!function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="//track.omguk.com/action/application/?action=Content&MID=" + OMID + "&PID=" + OPID + "&ref="+ ORef;var b=document.getElementsByTagName("body")[0];if(b)b.appendChild(a,b);else{var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}}();`;
}

/**
 * Injects the snippet if a OPTIMISEMEDIA_TRACKER variable is set on `window`
 */
export function injectOptimiseScript() {
  if (window.OPTIMISEMEDIA_TRACKER) {
    // Need to create an HTMLScriptElement, not just append an HTML with `<script>` tags inside
    // as these won't get run
    // https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml
    const script = document.createElement('script');
    script.innerHTML = optimiseSnippet();
    document.body.appendChild(script);
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/optimisemedia_tracker.js